import { EnquiryService, IEnquiryFilters } from '@/app/services/enquiry'
import {
  ErrorResponse,
  IPaginationParams,
  PaginatedQueryResponse,
} from '@/types/api'
import { IEnquiry } from '@/types/enquiry'

import { useQuery, UseQueryOptions } from 'react-query'

export function useEnquiries(
  filters: IEnquiryFilters = {},
  pagination: IPaginationParams = {},
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<IEnquiry>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IEnquiry>, ErrorResponse>(
    [EnquiryService.RESOURCE_PATH],
    () => EnquiryService.getEnquiries(filters, pagination),
    options
  )
}
